import { action, observable } from 'mobx';
import { TaskPreviewEditForm, } from 'application/dashboard/forms';
import {BaseEditViewStore } from 'core/stores';
import { ScheduleService } from 'application/schedule/services';

class TaskPreviewEditViewStore extends BaseEditViewStore {
    @observable accessor task = null;
    
    constructor(rootStore, componentParams) {
        const service = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'ordering-task-edit',
            autoInit:true,
            id: componentParams.modalParams.data.item.id,
            Form: TaskPreviewEditForm,
            actions: () => {
                return {
                    get: () => {
                        const response = componentParams.modalParams;
                        return response.data.item;
                    },
                    update: async (resource) => {
                        const response = await service.update({...this.task, ...resource});
                        this.task = {...this.task, ...resource};
                        return response.data;
                    }
                }
            },
            FormClass:TaskPreviewEditForm,
        });

        this.service = service;

        this.modalParams = componentParams.modalParams;

        this.task = componentParams.modalParams.data.item;

        this.deliveryTask = this.task.facilityScheduleDates.find(x=>x.facilityScheduleType.abrv === 'delivery');
        this.isDeliveryLink = this.deliveryTask != null;
        if(this.isDeliveryLink){
            this.form.update({
                deliveryNotes: this.deliveryTask.notes
            })
        }

        this.userRoles = this.rootStore.userStore.applicationUser.roles;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            if(this.isDeliveryLink){
                await this.service.updateLinkedTask({
                    ...this.deliveryTask,
                    notes: this.form.$('deliveryNotes').value,
                });
            }

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            if (this.modalParams.data.onSuccess) {
                this.modalParams.data.onSuccess();
            }
            
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default TaskPreviewEditViewStore;
